import React, {FC, useContext} from 'react';
import {Navigate} from 'react-router-dom';
import {UserContext, UserContextType} from './UserContext.ts';
import {applicationRegistry} from './utils.ts';
import {AccessStatus} from 'utils/userTypes.ts';
import {hasAccess} from 'appUtils/authentication/authenticationUtils.ts';
import {AppSettings} from 'config/appConfigs/appSettings.ts';


/**
 * Checks the user access and redirects to the first product/applicaton the user can access.
 */
const AppAccessNavigator: FC = () => {
  const {userState} = useContext(UserContext) as UserContextType;

  if (userState.status !== AccessStatus.Authenticated) {
    return <></>;
  }

  // // After successful authentication, navigate to the configured landing page
  // // instead of the first accessible app. This ensures users land on Home.
  // if (AppSettings.landingPage) {
  //   return <Navigate to={AppSettings.landingPage} />;
  // }

  // Fallback: find first route that is active and user has authorized access to
   


  for (const [, appAccess] of Object.entries(applicationRegistry)) {

    if (
      appAccess.isEnabled &&
      (appAccess.accessKey === undefined ||
        hasAccess(appAccess.accessKey, userState))
    ) {
      return <Navigate to={appAccess.indexRoute} />;
    }
  }

  // Final fallback to home
  return <Navigate to={'/home'} />;
};

export default AppAccessNavigator;
